import axios from "axios";

const API_BASE_URL = process.env.REACT_APP_API_URL || "http://localhost:5001";

export const addLabourTypeApi = (data) =>
  axios.post(`${API_BASE_URL}/api/labour-type/create`, data);

export const getLabourTypeListApi = (params = {}) =>
  axios.get(`${API_BASE_URL}/api/labour-type/list`, { params });

// id  → the MongoDB _id of the record
// data → { laborCat, name, rate, typeOfLabour }
export const updateLabourTypeApi = (id, data) =>
  axios.patch(`${API_BASE_URL}/api/labour-type/update/${id}`, data);

export const updateLabourTypeStatusApi = (labourTypeId, status) =>
  axios.post(`${API_BASE_URL}/api/update-labour-type-status`, {
    labourTypeId,
    status,
  });
